@if (isSelectionTable()) {
<div class="row actions">
  @if (visible) {
  <div class="col-1 btn-group">
    @if (isGroupDetails()) {
    <button
      class="btn btn-outline-danger btn-sm"
      (click)="ungroupCandidate()"
      matTooltip="Retirer les candidats du groupe">
      <span class="material-symbols-outlined pt-1"> group_remove </span>
    </button>
    } @if (!isGroupDetails()) {
    <button
      class="btn btn-outline-primary btn-sm"
      (click)="addCandidatesToGroup()"
      matTooltip="Ajouter les candidats selectionnés à un groupe">
      <span class="material-symbols-outlined pt-1"> group_add </span>
    </button>
    }
    <button
      [disabled]="selectedCandidates.length === 0"
      class="btn btn-outline-primary align-items-center btn-sm"
      (click)="sendEmailRemindCandidates()"
      [ngClass]="{ 'disabled-button': selectedCandidates.length === 0 }"
      matTooltip="Relancer les candidats sélectionnés">
      <span class="material-symbols-outlined pt-1">mail</span>
    </button>
    @if (canDeleteCandidate()) {
    <button
      class="btn btn-outline-danger btn-sm"
      (click)="deleteCandidate()"
      matTooltip="Supprimer les candidats sélectionnés">
      <span class="material-symbols-outlined pt-1"> delete </span>
    </button>
    }
  </div>
  }
</div>
}

<div class="table-responsive mt-2" [ngClass]="!isSelectionTable() ? 'mt-3' : ''">
  <div class="group-card d-flex flex-row align-items-center p-lg-2">
    @if (isSelectionTable()) {
    <div class="candidate-checkbox">
      <mat-checkbox
        (change)="$event ? masterToggle() : null"
        [checked]="allIsSelected"
        [indeterminate]="selectedCandidates.length !== 0 && !allIsSelected" />
    </div>
    }
    <span class="candidate-name"><b>Candidat</b></span>
    <span class="candidate-email"><b>Email</b></span>
    <span class="candidate-avancement"><b>Avancement</b></span>
  </div>
  @for (candidate of page().content; let i = $index; track candidate.id) {
  <div class="card mb-2 p-2 group-card flex-row" style="cursor: pointer" routerLink="/candidates/{{ candidate.id }}">
    @if (isSelectionTable()) {
    <div class="candidate-checkbox">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (change)="boxChecked(candidate)"
        [checked]="selectedCandidates.includes(candidate)" />
    </div>
    }
    <span class="candidate-name pt-2">{{ candidate.firstName }} {{ candidate.lastName.toUpperCase() }}</span>
    <span class="candidate-email pt-2">{{ candidate.email }}</span>
    <span class="candidate-avancement">
      @if (displayAssessment()) {
      <syn-exam-accordion [groupedTests]="groupedTest[i]" />
      }
    </span>
  </div>
  }
</div>
